import React from "react";

import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  message?: string;
  className?: string;
  iconSize?: "sm" | "md" | "lg";
}

const ICON_SIZES = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
};

export function LoadingState({
  message = "Loading...",
  className = "flex items-center justify-center gap-2",
  iconSize = "md",
}: LoadingStateProps) {
  return (
    <div className={className}>
      <Loader2
        className={`${ICON_SIZES[iconSize]} animate-spin text-zinc-500 dark:text-zinc-100`}
      />
      <span className="text-sm text-zinc-500 dark:text-zinc-100">
        {message}
      </span>
    </div>
  );
}
